import { Component, OnInit, Inject } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from '@angular/forms';
import { AbstractComponent } from '../../../../core/common/component/AbstractComponent';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginConfirmService } from './LoginConfirmService';
import { AuthService } from 'src/app/common/service/AuthService';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-login-confirm',
  templateUrl: './LoginConfirm.html',
  styleUrls: ['./LoginConfirm.scss'],
})
export class LoginConfirmComponent extends AbstractComponent {
  errorMessage = '';
  loginForm: FormGroup;
  submitted: boolean = false;
  loginInvalid: boolean = false;

  scope = {
    message: '',
  };
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private service: LoginConfirmService,
    private authService: AuthService
  ) {
    super();
    console.log('componentWillMount');
  }

  componentWillMount() {
    window.scrollTo(0, 0);
    this.document.body.style.backgroundColor = '#fff';
    this.loginForm = this.formBuilder.group({
      email: new FormControl('', [Validators.required]),
      password: new FormControl('', Validators.required),
    });
    this.route.params.subscribe((param) => {
      this.service.confirm(param.id).subscribe(
        (e) => {
          this.scope.message = 'メールアドレスの確認できました';
        },
        (e) => {}
      );
    });
  }

  login() {
    this.submitted = true;
    if (this.loginForm.invalid) {
      this.submitted = false;
      return false;
    }
    // this.router.navigate(['/dashboard']);
    let values = this.loginForm.value;
    this.authService.login(values.email, values.password).subscribe(
      (e) => {
        this.submitted = false;
        this.router.navigate(['/dashboard']);
      },
      (e) => {
        this.submitted = false;
        this.loginInvalid = true;
        this.errorMessage = 'IDまたパスワードが違います。';
        setTimeout(() => {
          this.loginInvalid = false;
        }, 1000);
      }
    );
  }
}
